<template>
  <div class="flex grow flex-col">
    <div class="flex grow flex-col overflow-hidden">
      <AnimatePresence>
        <Motion
          v-if="showMobileSidebar"
          key="mobile-sidebar"
          class="fixed inset-0 z-50 flex w-full flex-shrink-0 flex-col lg:hidden"
          :initial="{ x: '-100%' }"
          :animate="{ x: 0 }"
          :exit="{ x: '-100%' }"
          :transition="{ duration: 0.15, ease: 'easeOut' }"
        >
          <MobileSidebar />
        </Motion>
      </AnimatePresence>
      <div class="fixed inset-0 flex grow flex-col transition-spacing">
        <AppHeader>
          <slot name="header-content" />
        </AppHeader>
        <div
          class="flex grow overflow-y-auto"
          data-scroll-container
        >
          <div class="relative hidden w-1/3 md:block">
            <img
              src="/login.jpeg"
              class="h-screen object-cover"
            />
            <div class="absolute bottom-10 left-10 text-sm">
              <p class="font-bold text-white/90">
                Burano
              </p>
              <p class="text-white/80">
                Venice, Italy
              </p>
            </div>
          </div>
          <div class="flex grow flex-col items-center justify-between p-8">
            <div class="flex w-full max-w-sm grow flex-col justify-center">
              <slot />
            </div>
            <div>&nbsp;</div>
          </div>
        </div>
      </div>
    </div>
    <ModalContainer />
    <CookieConsentBanner />
  </div>
</template>

<script setup lang="ts">
const { showMobileSidebar } = useLayoutState()

defineProps<{
  hideFooter?: boolean
}>()
</script>
